<!--
 * @Author: 仙道
 * @Date: 2022-08-12 23:28:19
 * @LastEditTime: 2022-08-15 22:13:15
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/equipment/account/vue/DevListListForDetail.vue
-->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->

    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->

    <!-- table区域-begin -->
    <div>
      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="devName" slot-scope="text,record">
          <link-to-detail :id="record.id" :text="text" route-name="FusionDevice"></link-to-detail>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleDetail(record)">详情</a>
          <a-divider type="vertical" />
          <a @click="handleCopy(record)">复制</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <dev-list-modal @ok="modalFormOk" ref="modalForm"></dev-list-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DevListModal from './modules/DevListModal'
  import { getAction, postAction } from '../../../../api/manage'
  // import { DragTableMixin } from '@/mixins/DragTableMixin'
  import { omit } from 'lodash'
  export default {
    name: 'DevListList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      DevListModal
    },
    props: {
      query: {
        type: Object,
        default: () => { }
      }
    },
    data () {
      return {
        description: '设备台账管理页面',
        // 表头
        columns: [

          {
            title: '设备名称',
            align: 'center',
            dataIndex: 'devName',
            scopedSlots: { customRender: 'devName' },

          },

          {
            title: '表号',
            align: 'center',
            dataIndex: 'devTag'
          },
          {
            title: '父设备',
            align: 'center',
            dataIndex: 'parentId_dictText'
          },
          // {
          //   title: '设备类型ID',
          //   align: 'center',
          //   dataIndex: 'devClassId'
          // },
          {
            title: '设备类型',
            align: 'center',
            dataIndex: 'devClassId_dictText'
          },
          {
            title: '所属区域',
            align: 'center',
            dataIndex: 'areaName'
          },
          {
            title: '服役状态',
            align: 'center',
            dataIndex: 'serviceStatus',
            customRender: function (text) {
              return String(text) === '1' ? '运行中' : '停运'
            }
          },
          {
            title: '投运日期',
            align: 'center',
            dataIndex: 'operationDate',
            customRender: function (text) {
              return !text ? '' : (text.length > 10 ? text.substr(0, 10) : text)
            }
          },
          {
            title: '报废日期',
            align: 'center',
            dataIndex: 'retireDate',
            customRender: function (text) {
              return !text ? '' : (text.length > 10 ? text.substr(0, 10) : text)
            }
          },

          {
            title: '运行寿命(天)',
            align: 'center',
            dataIndex: 'runningLife'
          },


        ],
        isorter: {
          column: 'sort',
          order: 'asc'
        },
        queryParam: {
          devName: '',
          devClassId: '',
          parentId: '',

        },
        url: {
          list: '/device/devList/getListByManuId',
          delete: '/device/devList/delete',
          deleteBatch: '/device/devList/deleteBatch',
          exportXlsUrl: '/device/devList/exportXls',
          importExcelUrl: 'device/devList/importExcel',
          sort: '/device/devList/editSort',
          add: '/device/devList/add',
        },
        listPagination: {
          pageSize: 50,
          pageSizeOptions: ['50', '100', '200', '300']
        },
        queryParam: {},
        disableMixinCreated: true,
        dictOptions: {},
        superFieldList: [],
        deviceAddAttr: { "devName": "name", "devTag": "2", "parentId": "1538171098930270209", "devClassId": "6A9OC55DC4D4467CA23DEF1CE37B0059", "devProcessId": "1521373906911895553", "areaId": "1521415028513701890", "serviceStatus": "1" }
      }
    },
    created () {
      this.getSuperFieldList()
      this.queryParam = { ...this.query }
      this.loadData()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      }
    },
    methods: {
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = []
        // fieldList.push({ type: 'string', value: 'devName', text: '设备名称' })
        // fieldList.push({ type: 'string', value: 'devCode', text: '设备名称' })
        // fieldList.push({ type: 'string', value: 'devTag', text: '表号' })
        // fieldList.push({ type: 'int', value: 'parentId', text: '父设备ID' })
        // fieldList.push({ type: 'string', value: 'devClassId', text: '设备类型ID' })
        // fieldList.push({ type: 'int', value: 'devTypeId', text: '设备型号ID' })
        // fieldList.push({ type: 'string', value: 'areaId', text: '所属区域' })
        // fieldList.push({ type: 'string', value: 'serviceStatus', text: '服役状态' })
        // fieldList.push({ type: 'date', value: 'operationDate', text: '投运日期' })
        // fieldList.push({ type: 'date', value: 'retireDate', text: '报废日期' })
        // fieldList.push({ type: 'string', value: 'qrcode', text: '二维码' })
        // fieldList.push({ type: 'string', value: 'pictureObjId', text: '设备照片(OSS服务对象ID)' })
        // fieldList.push({ type: 'int', value: 'runningLife', text: '运行寿命(天)' })
        // fieldList.push({ type: 'int', value: 'tenantId', text: '租户id' })
        // fieldList.push({ type: 'string', value: 'orgId', text: '公司id' })
        // fieldList.push({ type: 'int', value: 'delFlag', text: '删除状态' })
        this.superFieldList = fieldList
      },
      async handleEdit (record) {
        const { result, code } = await getAction('/device/devList/queryDetailById', { id: record.id })
        if (code === 200) { this.$refs.modalForm.edit(result) }
        this.$refs.modalForm.title = '编辑'
        this.$refs.modalForm.disableSubmit = false
      },
      handleDetail (record) {
        this.$router.push({
          path: '/equipment/account/detail',
          query: {
            accountId: record.id
          }
        })
      },
      batchCopy () {
        if (!this.url.deleteBatch) {
          this.$message.error('请设置url.deleteBatch属性!')
          return
        }
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning('请选择一条记录！')
        } else {
          var ids = ''
          for (var a = 0; a < this.selectedRowKeys.length; a++) {
            ids += this.selectedRowKeys[a] + ','
          }
          var that = this



          this.$confirm({
            title: '确认复制',
            content: '是否复制选中设备数据?',
            onOk: function () {
              that.loading = true
              const selectData = that.selectionRows.map(rows => omit(rows, ['id']))
              //  that.handleCopy(selectData[0])
              //device/devList/batchInsert
              postAction('/device/devList/batchInsert', selectData).then((res) => {
                if (res.success) {
                  // 重新计算分页问题
                  that.reCalculatePage(that.selectedRowKeys.length)
                  that.$message.success('复制成功')
                  that.loadData()
                  that.onClearSelected()
                } else {
                  that.$message.warning(res.message)
                }
              }).finally(() => {
                that.loading = false
              })
            }
          })
        }

      },
      // 复制
      handleCopy (records) {
        const that = this
        const selectData = omit(records, ['id'])

        postAction(that.url.add, selectData).then((res) => {
          if (res.success) {
            // 重新计算分页问题
            that.reCalculatePage(that.selectedRowKeys.length)
            that.$message.success('复制成功')
            that.loadData()
            that.onClearSelected()
          } else {
            that.$message.warning(res.message)
          }
        }).finally(() => {
          that.loading = false
        })
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>
